<template>
  <footer class="px-4 footer align-content-center">
    <b-row class="justify-content-center">
      <b-col lg="6" v-show="false">
        <div class="copyright text-center text-lg-left text-muted">
          © {{ year }},
          <a class="font-weight-bold ml-1"
            >Bocapio. todos os direitos reservados</a
          >
        </div>
      </b-col>

        <b-nav class="nav-footer text-center">
          <b-nav-item class="w-100" href="//janoo.com.br/janoo-uma-solucao-completa-para-a-gestao-de-atrativos-turisticos/" target="_blank">
            Janoo® - v{{bcVersion}}
          </b-nav-item>
        </b-nav>

    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      bcVersion: process.env.VUE_APP_VERSION,
      year: new Date().getFullYear()
    };
  },
  created() {
    if(!localStorage.getItem('bc_version') || (localStorage.getItem('bc_version') && localStorage.getItem('bc_version') != this.bcVersion)){
      localStorage.setItem('bc_version', this.bcVersion)
      window.location.reload(true)
    }
    console.log('sistema.janoo.com.br® version: ', localStorage.getItem('bc_version'))
  }
};
</script>
<style></style>
